import { environments } from '@8fig/environments';
import { AppTheme } from '../themes/themes';

export function isProd() {
  return process.env.REACT_APP_ENV === environments.prod;
}

export function is8DataApp() {
  return process.env.REACT_APP_THEME === AppTheme['8DATA'];
}
